import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiMutationHook } from '../../../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  type HttpHeaders,
} from '../../../../common/queryClient/getMutationFn';
import { AlgorithmUrl } from '../../query/AlgorithmUrl';
import { AlgorithmJoinsAndMappingsGraphMutationDtoSchema } from '../schema/AlgorithmJoinsAndMappingsGraphMutationDtoSchema';
import type { AlgorithmJoinsAndMappingsGraphValidFormDataType } from '../schema/types';

const putAlgorithmJoinsAndMappings = (
  id: number,
  data: Partial<AlgorithmJoinsAndMappingsGraphValidFormDataType>,
  headers?: HttpHeaders,
) =>
  apiClient
    .put<AlgorithmJoinsAndMappingsGraphValidFormDataType>(
      expand(AlgorithmUrl.MAPPINGS_AND_JOINS, { id }),
      AlgorithmJoinsAndMappingsGraphMutationDtoSchema.parse(data),
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

export const useAlgorithmJoinsAndMappingsMutation = createApiMutationHook(
  ['algorithmJoinsAndMappings'],
  getMutationFn(undefined, putAlgorithmJoinsAndMappings),
);
